module.exports = __webpack_public_path__ + "img/logo.a86f5639.png";